import React from 'react';

interface LiveIndicatorProps {
  /** Whether the WebSocket connection is currently active */
  connected: boolean;
}

/**
 * Visual connection-state indicator for the real-time price feed.
 *
 * - Connected  → green pulsing dot + "Live" label
 * - Disconnected → amber static dot + "Delayed" label
 *
 * Used in DashboardPage and PortfolioAnalyticsPage headers (Chunk 108).
 */
const LiveIndicator: React.FC<LiveIndicatorProps> = ({ connected }) => {
  if (connected) {
    return (
      <span
        className="inline-flex items-center gap-1.5 text-xs font-medium text-emerald-400"
        aria-label="Live price feed connected"
        role="status"
      >
        <span className="relative flex h-2 w-2" aria-hidden="true">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        Live
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs font-medium text-amber-400"
      aria-label="Price feed disconnected — showing delayed data"
      role="status"
    >
      <span className="relative flex h-2 w-2" aria-hidden="true">
        <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500" />
      </span>
      Delayed
    </span>
  );
};

export default LiveIndicator;
